import { generateShades } from '@public/customization/paletteGenerator';
import { Card, Grid } from '@ts/storybook';

interface TestPageProps {}

const TestPage = ({}: TestPageProps) => {
  const shades = generateShades([
    { tone: '1000', hex: '#201b50' },
    { tone: '500', hex: '#077bc0' },
  ]);
  const TONES = ['000', '20', '50', '100', '200', '300', '400', '500', '600', '700', '800', '900', '1000'];
  return (
    <Grid container spacing={2} p={2} className="w-full">
      <div className="flex my-20 gap-1">
        {TONES.map(tone => (
          <div key={tone} className="flex flex-col gap-2">
            <div
              style={{
                backgroundColor: shades[tone],
                width: 100,
                height: 100,
                borderRadius: 8,
                position: 'relative',
              }}
            />
            <p>{shades[tone]}</p>
          </div>
        ))}
      </div>
      <Card icon="stars" title="Test" hoverable></Card>
      <Card icon="forklift" title="Test" variant="outlined" hoverable></Card>
    </Grid>
  );
};

export default TestPage;
